import { Component, OnInit, HostListener } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router'
import { Title, Meta } from '@angular/platform-browser';  
// import * as socialImage from "src/assets/img/social";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'omni-marketing-app';

  homeImg = "https://omni-marketing-assets.s3.amazonaws.com/OMNI_1.png";
  indImg = "https://omni-marketing-assets.s3.amazonaws.com/OMNI_2.png";
  demoImg = "https://omni-marketing-assets.s3.amazonaws.com/OMNI_3.png";

  metaInfo = {
    home:{
      keywords:"artificial intelligence, ai, rpa, robotic process automation, OCR, natural language processing, nlp, automation, ai rpa aggregator, ai rpa upskilling plaform",
      description:"Learn & practice on hands-on training platform for AI & RPA skills at OMNI. It has a unique collection of top 25 AI & RPA tools. Build your own automation bots."      
    },
    partner:{
      keywords:"rpa technologies, best RPA tool, process automation, rpa software,rpa automation, rpa bot, machine learning, rpa certification",
      description:"OMNI has partnered with world's best AI & RPA learning tools which are providing industry recognized certification courses & programs on  AI & RPA"
    },
    contact:{
      keywords:"top rpa tool, rpa companies, rpa consultant nearby, rpa software development, business process automation, rpa vendors",
      description:"Omni provides guided training platform that  empowers enterprises & individuals to build their own AI & RPA bots using top 25 automation tools and platforms "
    },
    resources:{
      keywords:"what is rpa, benefits of rpa, citisen development, AI & RPA upskilling, rpa case studies, application of rpa, rpa in business",
      description:"OMNI provides practical application-based  platform to build real life AI & RPA bots. Learn to build your own RPA bot."
    },
    schedule:{
      keywords:"automation course, poc, rpa course, learn rpa, cetification course, best rpa platform, robotic process automation course",
      description:"Industry recognized certification & Hands-on RPA bot building platform that trains you to build your own automation bot. Live project-based training on AI & RPA"
    }
  }

  constructor(private router: Router, private titleService: Title,  
    private metaTagService: Meta ){
    // router.events.subscribe((routerEvent: Event) => this.checkRouterEvent(routerEvent));
  }

  ngOnInit() {  
    this.router.events.subscribe((routerEvent: Event) => this.checkRouterEvent(routerEvent));   
  }

  checkRouterEvent(routerEvent: Event): void{     
    if(routerEvent instanceof NavigationStart){
      console.log(routerEvent.url);
      this.handleMetaTags(routerEvent.url);
    }
    else if(routerEvent instanceof NavigationEnd || routerEvent instanceof NavigationError || routerEvent instanceof NavigationCancel){      
    }
  }

  handleMetaTags(url){
    this.removeAllTags();
    switch(url){
      case '/':
        this.metaTagService.addTags([
          {name: "keywords", content: this.metaInfo.home.keywords},
          {name: "description", content: this.metaInfo.home.description}
        ]);  
        this.metaTagService.updateTag(
          {property:"og:url", content: "https://omnicoe.com/"},
          `property='og:url'`
        );
        this.metaTagService.updateTag(
          {property:"og:image", content: this.homeImg},
          `property='og:image'`
        )      
        break;
      case '/partner':
        this.metaTagService.addTags([
          {name: "keywords", content: this.metaInfo.partner.keywords},
          {name: "description", content: this.metaInfo.partner.description}
        ]);
        break;
      case '/contact':
          this.metaTagService.addTags([
            {name: "keywords", content: this.metaInfo.contact.keywords},
            {name: "description", content: this.metaInfo.contact.description}
          ]);
          break; 
      case '/resources':
        this.metaTagService.addTags([
          {name: "keywords", content: this.metaInfo.resources.keywords},
          {name: "description", content: this.metaInfo.resources.description}
        ]);
        break; 
      case '/schedule-demo':
        this.metaTagService.addTags([
          {name: "keywords", content: this.metaInfo.schedule.keywords},
          {name: "description", content: this.metaInfo.schedule.description}
        ]);
        this.metaTagService.updateTag(
          {property:"og:url", content: "https://omnicoe.com/schedule-demo"},
          `property='og:url'`
        );
        this.metaTagService.updateTag(
          {property:"og:image", content: this.demoImg},
          `property='og:image'`
        ) 
        break; 
      case '/forindividual':
        this.metaTagService.updateTag(
          {property:"og:url", content: "https://omnicoe.com/forindividual"},
          `property='og:url'`
        );
        this.metaTagService.updateTag(
          {property:"og:image", content: this.indImg},
          `property='og:image'`
        ) 
        break; 
    }
  }

  removeAllTags(){
    this.metaTagService.removeTag('name="keywords"');
    this.metaTagService.removeTag('name="description"');
    // this.metaTagService.removeTag("property='og:url'");
    // this.metaTagService.removeTag("property='og:image'");
  }



}
